import React, {useEffect, useState} from 'react';
import {
    Box,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    Select,
    Typography
} from "@deere/fuel-react";
import {PERIOD_QUESTION, RESPONSE_BY_QUESTION} from "../shared/Constants";
import {Controller} from "react-hook-form";
import {FormSelect} from "../shared/FormSelect";
import {DatePicker} from "@deere/ux.uxframe-react";
import DeleteIcon from "@material-ui/icons/Delete";
import TextField from "@material-ui/core/TextField";
import {formatDate, generateFiscalYear, toCapitalizeSplitStr} from "../shared/utils";
import {useAuthConfig} from "../shared/helper";
import {useOktaAuth} from "@okta/okta-react";

export const CampaignPeriod = ({
                                   control,
                                   supplierName,
                                   supplierNumber,
                                   currentData,
                                   onDelete,
                                   errors,
                                   setValue,
                                   onPeriodValChange,
    onFiscalYearChange
                               }) => {
    let authAxios = useAuthConfig();
    const {authState} = useOktaAuth();
    const [fyList, setFyList] = useState([]);
    const [periodList, setPeriodList] = useState([]);
    const [supplierValue, setSupplierValue] = useState("");
    const [currentYear, setCurrentYear] = useState();

    const getCampaignPeriods = async () => {
        try {
            return await authAxios.get(`/campaign/periods`);
        } catch (e) {
            console.error(e);
        }
    };

    const getCurrentCalendar = async () => {
        try {
            return await authAxios.get(`/calendar/current`);
        } catch (e) {
            console.error(e);
        }
    };

    const handlePeriodChange = (event) => {
        onPeriodValChange(periodList.filter(periodObj => periodObj.id === parseInt(event.target.value))[0])
    };

    const handleFiscalYearChange = (event) => {
        onFiscalYearChange(event.target.value)
    }

    useEffect(() => {
        if (supplierName && supplierName.length > 0) {
            setSupplierValue(`${toCapitalizeSplitStr(supplierName)} - ${parseInt(supplierNumber)}`);
            setValue('selectedSupplier', supplierNumber, {shouldValidate: true})
        }

        return () => {
            setSupplierValue("");
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [supplierName]);

    useEffect(() => {
        getCampaignPeriods().then(res => {
            const data = res.data;
            setPeriodList(data);
        });

        getCurrentCalendar().then(res => {
            setCurrentYear(res.data.currentFiscalYear)
            setValue("fiscalYear", currentData.fiscalYear ? currentData.fiscalYear : res.data.currentFiscalYear)
            const list = generateFiscalYear(res.data.currentFiscalYear);
            setFyList(list);
        });

        return () => {
            setFyList([]);
            setPeriodList([]);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState]);

    return (
        <Box mt={2}>
            <Grid container alignItems="flex-start" spacing={4}>
                <Grid item xs={12}>
                    <Typography variant="label" display="inline">
                        {PERIOD_QUESTION}{" "}
                    </Typography>
                    <span
                        aria-label="required field"
                        className="uxf-is-required"
                    > * </span>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="fiscalYear">Fiscal Year</InputLabel>
                        <Controller
                            rules={{required: true}}
                            control={control}
                            defaultValue={currentData.fiscalYear ? currentData.fiscalYear : currentYear}
                            name={"fiscalYear"}
                            render={({onChange, value}) => (
                                <Select native
                                        labelId={"fiscalYear"}
                                        id={"fiscalYear"}
                                        value={value}
                                        onChange={(e) => {
                                            onChange(e);
                                            handleFiscalYearChange(e);
                                        }}>
                                    {fyList && fyList.map((item, index) => {
                                        return (
                                            <option
                                                key={index}
                                                value={item}>{item}</option>
                                        );
                                    })
                                    }
                                </Select>
                            )}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormSelect
                        label={"period"}
                        defValue={1 /* Default to mid-year for now. Should be automatic, but we're 4 components deep right now, and it broken */}
                        name={"period"}
                        options={periodList}
                        onTypeChange={handlePeriodChange}
                        control={control}
                        isShowSelect={false}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControl required fullWidth error>
                        <InputLabel htmlFor="responseByDate">{RESPONSE_BY_QUESTION}</InputLabel>
                        <Controller
                            rules={{required: true}}
                            control={control}
                            defaultValue={currentData.dueDate ? formatDate(new Date(currentData.dueDate)) : ""}
                            name="responseByDate"
                            render={({onChange, value}) => (
                                <DatePicker
                                    id="uxf-date-picker-1"
                                    inputAriaLabel="date format: dd-mmm-yyyy"
                                    inputProps={{value: currentData.dueDate}}
                                    hideLabel={true}
                                    defaultValue={currentData.dueDate}
                                    flatPickrOptions={
                                        {
                                            minDate: new Date(), onChange: e => {
                                                onChange(formatDate(e[0]));
                                            }
                                        }
                                    }/>
                            )}
                        />
                        <FormHelperText>{errors.responseByDate && "Select a Date in future"}</FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth required error>
                        <InputLabel htmlFor="selectedSupplier">Selected Supplier</InputLabel>
                        <Controller
                            rules={{required: true}}
                            control={control}
                            defaultValue={supplierValue}
                            value={supplierValue}
                            name="selectedSupplier"
                            render={({onChange, value}) => (
                                <TextField
                                    id="supplier-name"
                                    onChange={(e) => {
                                        onChange(e);
                                    }}
                                    value={supplierValue === "" ? "Not Selected" : supplierValue}
                                    InputProps={{
                                        readOnly: true,
                                        disableUnderline: true,
                                        endAdornment: (
                                            supplierValue === "" ? (<></>) : (
                                                <InputAdornment position="end">
                                                    <IconButton aria-label="delete" edge="end" onClick={onDelete}>
                                                        <DeleteIcon/>
                                                    </IconButton>
                                                </InputAdornment>)
                                        )
                                    }}
                                    size="small"
                                    variant="standard"
                                />
                            )}
                        />
                        <FormHelperText>{errors.selectedSupplier && "Please select a Supplier"}</FormHelperText>
                    </FormControl>
                </Grid>
            </Grid>
        </Box>
    );
};
